<template>
    <!-- Top progress line -->
    <div class="px-6" v-if="step > 1" :class="{'error-step': error != '' && error}" :id="'step'+step">
        <div class="relative">
            <div
                class="-ml-px absolute top-0 left-4 w-0.5 h-12"
                :class="active || done ? 'bg-green-600' : 'bg-gray-200'"
                aria-hidden="true"
            />
        </div>
    </div>

    <div class="p-6" :class="[!active && !done ? 'bg-gray-50' : '', step == 1 && active ? 'rounded-t-xl' : '', error != '' && error ? 'error-step' : '']">
        <div class="relative">
            <div
                class="-ml-px absolute mt-0.5 top-6 left-4 w-0.5 h-full"
                :class="done ? 'bg-green-600' : 'bg-gray-200'"
                aria-hidden="true"
            />

            <div class="relative flex items-start group" aria-current="step">
                <span class="h-9 flex items-center" aria-hidden="true">
                    <span
                        class="relative w-8 h-8 flex items-center justify-center rounded-full font-bold"
                        :class="[
                            done ? 'bg-green-600 text-white' : '',
                            active ? 'border-green-600 border-2 bg-white text-green-600' : '',
                            !done && !active ? 'bg-white border border-gray-200 text-gray-400' : '',
                        ]"
                    >
                        {{ step }}
                    </span>
                </span>

                <!-- Title -->
                <span class="ml-4 my-1 min-w-0 flex font-semibold text-lg items-center" :class="[active || done ? '' : 'text-gray-400']">
                    <!-- <fa
                        v-if="icon"
                        :icon="['fas', icon]"
                        class="h-5 w-5 inline-block mr-3"
                    /> -->
                    <span>{{ title }}</span>
                </span>
            </div>
            <div class="pl-12">
                <div class="text-gray-500">
                    <!-- Description -->
                    <slot name="description" v-if="active || done">
                        <div v-html="description"></div>
                    </slot>
                </div>

                <slot name="top"></slot>

                <!-- Option -->
                <transition name="drop" v-if="!disabled">
                    <div v-if="active || done">
                        <slot name="option"></slot>
                    </div>
                </transition>

                <transition name="pop">
                    <validation v-if="error && (active || done)" :error="error" />
                </transition>
            </div>
        </div>
        
    </div>
    <slot name="advice"></slot>
</template>

<script>
import Validation from '@/Components/Validation.vue';

export default {
    components: {
        Validation,
    },
    props: {
        title: String,
        description: String,
        step: Number,
        active: Boolean,
        done: Boolean,
        error: String | Boolean,
        disabled: Boolean,
        icon: String,
    },

    data() {
        return {};
    },

    setup(props) {},
};
</script>
